"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyScheduleRouteResponseSchema = exports.scheduleRouteOptimizationSchema = exports.applyScheduleRouteRequestSchema = exports.optimizeScheduleRouteRequestSchema = exports.scheduleDailyRoutesResponseSchema = exports.scheduleRouteExcludedStopSchema = exports.scheduleDailyRouteSchema = exports.scheduleRouteTimingIssueSchema = exports.scheduleDailyRouteLegSchema = exports.scheduleDailyRouteStopSchema = exports.scheduleRouteComputationStatusSchema = exports.mobileScheduleCreateOptionsResponseSchema = exports.mobileScheduleResponseSchema = exports.mobileScheduleQuerySchema = exports.mobileScheduleAccessSchema = exports.scheduleDailyRoutesQuerySchema = exports.scheduleLocalDateSchema = exports.scheduleResponseSchema = exports.unscheduledJobSchema = exports.scheduleEstimateSchema = exports.scheduleEventSchema = exports.createScheduleEventRequestSchema = exports.scheduleEventAddressResponseSchema = exports.updateScheduleEventAddressRequestSchema = exports.scheduleEventAddressSchema = exports.scheduleAppointmentSchema = exports.scheduleConflictSchema = exports.scheduleServiceLocationSchema = exports.rescheduleAppointmentRequestSchema = exports.scheduleRangeSchema = void 0;
const zod_1 = require("zod");
const business_1 = require("./business");
const job_1 = require("./job");
const catalog_1 = require("./catalog");
const customer_1 = require("./customer");
const estimate_1 = require("./estimate");
const team_1 = require("./team");
const millisecondsPerHour = 60 * 60 * 1_000;
// A 42-day local calendar grid can be longer in UTC when its offset moves back.
const maximumScheduleRangeDuration = 42 * 24 * millisecondsPerHour + 2 * millisecondsPerHour;
exports.scheduleRangeSchema = zod_1.z
    .object({
    from: zod_1.z.string().datetime(),
    to: zod_1.z.string().datetime(),
})
    .refine((value) => Date.parse(value.to) > Date.parse(value.from), {
    path: ["to"],
    message: "Schedule end must follow start.",
})
    .refine((value) => Date.parse(value.to) - Date.parse(value.from) <=
    maximumScheduleRangeDuration, {
    path: ["to"],
    message: "Schedule range cannot exceed 42 calendar days.",
});
exports.rescheduleAppointmentRequestSchema = zod_1.z
    .object({
    startAt: zod_1.z.string().datetime(),
    endAt: zod_1.z.string().datetime(),
    assignedMembershipId: zod_1.z.string().uuid().nullable(),
})
    .refine((value) => Date.parse(value.endAt) > Date.parse(value.startAt), {
    path: ["endAt"],
    message: "End time must be after start time.",
});
exports.scheduleServiceLocationSchema = job_1.jobServiceLocationSchema.extend({
    latitude: zod_1.z.number().min(-90).max(90).nullable(),
    longitude: zod_1.z.number().min(-180).max(180).nullable(),
});
exports.scheduleConflictSchema = zod_1.z.object({
    appointmentId: zod_1.z.string().uuid(),
    jobId: zod_1.z.string().uuid(),
    jobNumber: zod_1.z.number().int().positive(),
    overlapStartAt: zod_1.z.string().datetime(),
    overlapEndAt: zod_1.z.string().datetime(),
});
exports.scheduleAppointmentSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    jobId: zod_1.z.string().uuid(),
    jobNumber: zod_1.z.number().int().positive(),
    jobSummary: zod_1.z.string(),
    jobPriority: job_1.jobPrioritySchema,
    jobStatus: job_1.jobStatusSchema,
    startAt: zod_1.z.string().datetime(),
    endAt: zod_1.z.string().datetime(),
    status: job_1.appointmentStatusSchema,
    assignee: team_1.scheduledTeamMemberSchema.nullable(),
    customer: job_1.jobCustomerSchema,
    serviceLocation: exports.scheduleServiceLocationSchema,
    hasConflict: zod_1.z.boolean(),
    conflicts: zod_1.z.array(exports.scheduleConflictSchema).optional(),
});
exports.scheduleEventAddressSchema = zod_1.z
    .string()
    .trim()
    .min(5)
    .max(500)
    .nullable();
exports.updateScheduleEventAddressRequestSchema = zod_1.z.object({
    address: exports.scheduleEventAddressSchema,
});
exports.scheduleEventAddressResponseSchema = exports.updateScheduleEventAddressRequestSchema.extend({
    eventId: zod_1.z.string().uuid(),
});
exports.createScheduleEventRequestSchema = zod_1.z
    .object({
    title: zod_1.z.string().trim().min(2).max(160),
    notes: zod_1.z.string().trim().max(5_000).optional(),
    address: exports.scheduleEventAddressSchema.optional(),
    startAt: zod_1.z.string().datetime(),
    endAt: zod_1.z.string().datetime(),
    assignedMembershipId: zod_1.z.string().uuid().nullable().optional(),
})
    .refine((value) => Date.parse(value.endAt) > Date.parse(value.startAt), {
    path: ["endAt"],
    message: "End time must be after start time.",
});
exports.scheduleEventSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    title: zod_1.z.string(),
    notes: zod_1.z.string().nullable(),
    address: exports.scheduleEventAddressSchema.optional(),
    startAt: zod_1.z.string().datetime(),
    endAt: zod_1.z.string().datetime(),
    assignee: team_1.scheduledTeamMemberSchema.nullable(),
    createdAt: zod_1.z.string().datetime(),
});
exports.scheduleEstimateSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    estimateNumber: zod_1.z.number().int().positive(),
    status: estimate_1.estimateStatusSchema,
    startAt: zod_1.z.string().datetime(),
    endAt: zod_1.z.string().datetime(),
    assignee: team_1.scheduledTeamMemberSchema.nullable(),
    customer: job_1.jobCustomerSchema,
    serviceLocation: exports.scheduleServiceLocationSchema,
    totalCents: zod_1.z.number().int().nonnegative(),
});
exports.unscheduledJobSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    jobNumber: zod_1.z.number().int().positive(),
    summary: zod_1.z.string(),
    priority: job_1.jobPrioritySchema,
    customer: job_1.jobCustomerSchema,
    serviceLocation: exports.scheduleServiceLocationSchema,
    createdAt: zod_1.z.string().datetime(),
});
exports.scheduleResponseSchema = zod_1.z.object({
    operationalLocation: business_1.operationalLocationAccessSchema,
    timezone: zod_1.z.string(),
    from: zod_1.z.string().datetime(),
    to: zod_1.z.string().datetime(),
    appointments: zod_1.z.array(exports.scheduleAppointmentSchema),
    estimates: zod_1.z.array(exports.scheduleEstimateSchema).default([]),
    events: zod_1.z.array(exports.scheduleEventSchema),
    unscheduledJobs: zod_1.z.array(exports.unscheduledJobSchema),
    teamMembers: zod_1.z.array(team_1.scheduledTeamMemberSchema),
});
exports.scheduleLocalDateSchema = zod_1.z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, "Enter a date as YYYY-MM-DD.")
    .refine((value) => {
    const parsed = new Date(`${value}T00:00:00.000Z`);
    return (!Number.isNaN(parsed.valueOf()) && parsed.toISOString().startsWith(value));
}, "Enter a valid calendar date.");
exports.scheduleDailyRoutesQuerySchema = zod_1.z.object({
    date: exports.scheduleLocalDateSchema,
});
exports.mobileScheduleAccessSchema = zod_1.z.enum(["ASSIGNED", "TEAM"]);
exports.mobileScheduleQuerySchema = zod_1.z.object({
    date: exports.scheduleLocalDateSchema,
});
exports.mobileScheduleResponseSchema = exports.scheduleResponseSchema.extend({
    date: exports.scheduleLocalDateSchema,
    access: exports.mobileScheduleAccessSchema,
});
exports.mobileScheduleCreateOptionsResponseSchema = zod_1.z.object({
    customers: zod_1.z.array(job_1.jobCustomerSchema.extend({
        contacts: zod_1.z.array(customer_1.customerContactSchema),
        locations: zod_1.z.array(job_1.jobServiceLocationSchema),
    })),
    operationalLocations: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string().uuid(),
        name: zod_1.z.string(),
        timezone: zod_1.z.string(),
        isDefault: zod_1.z.boolean(),
    })),
    catalogItems: zod_1.z.array(catalog_1.catalogItemSchema),
    teamMembers: zod_1.z.array(team_1.teamMemberSchema),
});
exports.scheduleRouteComputationStatusSchema = zod_1.z.enum([
    "READY",
    "SINGLE_STOP",
    "NOT_CONFIGURED",
    "FAILED",
    "TOO_MANY_STOPS",
]);
exports.scheduleDailyRouteStopSchema = zod_1.z.object({
    sequence: zod_1.z.number().int().positive(),
    appointmentId: zod_1.z.string().uuid(),
    jobId: zod_1.z.string().uuid(),
    jobNumber: zod_1.z.number().int().positive(),
    jobSummary: zod_1.z.string(),
    startAt: zod_1.z.string().datetime(),
    endAt: zod_1.z.string().datetime(),
    customer: job_1.jobCustomerSchema,
    serviceLocation: exports.scheduleServiceLocationSchema.extend({
        latitude: zod_1.z.number().min(-90).max(90),
        longitude: zod_1.z.number().min(-180).max(180),
    }),
});
exports.scheduleDailyRouteLegSchema = zod_1.z.object({
    fromAppointmentId: zod_1.z.string().uuid(),
    toAppointmentId: zod_1.z.string().uuid(),
    distanceMeters: zod_1.z.number().int().nonnegative(),
    durationSeconds: zod_1.z.number().int().nonnegative(),
    encodedPolyline: zod_1.z.string().min(1).nullable().optional(),
});
exports.scheduleRouteTimingIssueSchema = zod_1.z.object({
    fromAppointmentId: zod_1.z.string().uuid(),
    toAppointmentId: zod_1.z.string().uuid(),
    kind: zod_1.z.enum(["OVERLAP", "INSUFFICIENT_TRAVEL_TIME"]),
    shortfallSeconds: zod_1.z.number().int().positive(),
});
exports.scheduleDailyRouteSchema = zod_1.z.object({
    membershipId: zod_1.z.string().uuid(),
    technician: team_1.scheduledTeamMemberSchema,
    status: exports.scheduleRouteComputationStatusSchema,
    stops: zod_1.z.array(exports.scheduleDailyRouteStopSchema),
    legs: zod_1.z.array(exports.scheduleDailyRouteLegSchema),
    totalDistanceMeters: zod_1.z.number().int().nonnegative(),
    totalDurationSeconds: zod_1.z.number().int().nonnegative(),
    encodedPolyline: zod_1.z.string().min(1).nullable(),
    mapsUrl: zod_1.z.string().url().nullable(),
    warning: zod_1.z.string().nullable(),
    timingIssues: zod_1.z.array(exports.scheduleRouteTimingIssueSchema).optional(),
});
exports.scheduleRouteExcludedStopSchema = zod_1.z.object({
    appointmentId: zod_1.z.string().uuid(),
    jobId: zod_1.z.string().uuid(),
    jobNumber: zod_1.z.number().int().positive(),
    customerId: zod_1.z.string().uuid(),
    serviceLocationId: zod_1.z.string().uuid(),
    reason: zod_1.z.literal("MISSING_COORDINATES"),
});
exports.scheduleDailyRoutesResponseSchema = zod_1.z.object({
    date: zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    timezone: zod_1.z.string(),
    providerConfigured: zod_1.z.boolean(),
    generatedAt: zod_1.z.string().datetime(),
    routes: zod_1.z.array(exports.scheduleDailyRouteSchema),
    excludedStops: zod_1.z.array(exports.scheduleRouteExcludedStopSchema),
});
exports.optimizeScheduleRouteRequestSchema = exports.scheduleDailyRoutesQuerySchema.extend({
    membershipId: zod_1.z.string().uuid(),
});
exports.applyScheduleRouteRequestSchema = zod_1.z.object({
    proposalId: zod_1.z.string().uuid(),
});
exports.scheduleRouteOptimizationSchema = zod_1.z.object({
    proposalId: zod_1.z.string().uuid(),
    expiresAt: zod_1.z.string().datetime(),
    date: exports.scheduleLocalDateSchema,
    timezone: zod_1.z.string(),
    original: exports.scheduleDailyRouteSchema,
    proposed: exports.scheduleDailyRouteSchema,
    issues: zod_1.z.array(zod_1.z.string()),
    canApply: zod_1.z.boolean(),
});
exports.applyScheduleRouteResponseSchema = zod_1.z.object({
    applied: zod_1.z.literal(true),
});
//# sourceMappingURL=schedule.js.map